import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionEmpresaResponsablesAgregarComponent {
  data = {}
  idProyecto
  onAdd
  onClose
  responsables

  constructor (ViaticosProyectos, ViaticosProyectosColaboradores, ViaticosProyectosProyectoResponsables) {
    this.ViaticosProyectos = ViaticosProyectos
    this.ViaticosProyectosColaboradores = ViaticosProyectosColaboradores
    this.ViaticosProyectosProyectoResponsables = ViaticosProyectosProyectoResponsables
  }

  $onInit () {
    this.promise = this.traerEmpleados()
  }

  agregar () {
    this.data.usuario = this.data.usuario.usuario
    if (this.data.requerido && this.responsables.length === 0) {
      this.data.posicion = 1
    }
    this.ViaticosProyectosProyectoResponsables.post(this.idProyecto, this.data)
      .then(({data}) => {
        this.onAdd({$event: data})
        this.onClose()
      })
  }

  traerProyectos () {
    this.data.id_proyecto = undefined
    this.ViaticosProyectos.get(this.data.id_pagadora)
      .then(({data}) => {
        this.proyectos = data
      })
  }

  traerEmpleados () {
    return this.ViaticosProyectosColaboradores.get('00')
      .then(({data}) => {
        this.colaboradores = data
        const posiciones = this.responsables.map((item) => {
          return item.posicion
        })
        this.posiciones = []
        const max = this.responsables.length === 0 ? 0 : Math.max.apply(null, posiciones)
        for (let i = 1; i <= max + 1; i++) {
          this.posiciones.push(i)
        }
        this.colaboradores = this.colaboradores.filter((item) => {
          let existe = this.responsables.some((elemento) => (item.usuario === elemento.usuario))
          return !existe ? item : false
        })
      })
  }
}

module.component('viaticosConfiguracionEmpresaResponsablesAgregar', {
  controller: ViaticosConfiguracionEmpresaResponsablesAgregarComponent,
  template,
  bindings: {
    idProyecto: '<',
    responsables: '<',
    onAdd: '&',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/empresa/responsables/agregar/component.js